<template>
    <basic-header pretitle="Aqfer graph managment" title="Graph My Data" :compact="true" />
    <div class="container-fluid">
        <tabs :tabs="graphMyDataTabs">
            <template v-slot:graphMyDataAnalyser>
                <GraphMyDataAnalyser></GraphMyDataAnalyser>
            </template>
        </tabs>
    </div>
</template>
<script>
import BasicHeader from "../../components/BasicHeader.vue";
import Tabs from "../../components/Tabs.vue";
import GraphMyDataAnalyser from "./GraphMyDataAnalyser.vue";
export default {
    name: "Graph My Data",
    components: { GraphMyDataAnalyser, BasicHeader, Tabs },
    data() {
        return {
            graphMyDataTabs: [
                {
                    name: "Graph My Data Analyser",
                    id: "1",
                    slot: "graphMyDataAnalyser"
                }
            ]
        }
    },
}
</script>
<style></style>